export const tableHeader = [
  { id: "scfId", type: "text", label: "Código de Controle", sortable: true },
  { id: "scfControl", type: "text", label: "Controle", sortable: true },
  { id: "scfDomain", type: "dropdown", label: "Domínio", sortable: true },
  { id: "controlWeighting", type: "number", label: "Peso do Controle", sortable: true },
  { id: "vinculado", type: "boolean", label: 'Vinculo', sortable: true },
  { id: "actions-add", type: "actions-add", label: "" },
];
